/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import { LegacyRef } from 'react';

import { useAppContext } from 'providers/AppProvider';
import installmentReportsService from 'service/installmentReports';
import styles from './installment.module.scss';

interface InstallmentReportBoxesesProps {
  selectedCurrencyPid?: number;
  dateFrom: any;
  dateTo: any;
  calculateAll: any;
  updatePaymenBox: any;
}
const InstallmentReportBoxeses = ({
  selectedCurrencyPid,
  dateFrom,
  dateTo,
  calculateAll,
  updatePaymenBox
}: InstallmentReportBoxesesProps) => {
  const {
    config: { theme }
  } = useAppContext();

  const { t } = useTranslation();

  /* prettier-ignore */
  const adjustedDateTo =
    !dateFrom && !dateTo
      ? undefined
      : dateTo === dateFrom
        ? dateFrom + 86400000
        : dateTo
          ? dateTo + 86400000 
          : undefined;

  const { data } = useQuery(
    [
      'GET_INSTALLMENT_STATUS',
      selectedCurrencyPid,
      adjustedDateTo,
      dateFrom,
      calculateAll,
      updatePaymenBox
    ],
    async () => {
      if (selectedCurrencyPid !== 0) {
        const res = await installmentReportsService
          .getListInstallmentStatus(selectedCurrencyPid, {
            date_from: dateFrom,
            date_to: adjustedDateTo,
            limit: 10,
            offset: 0,
            calculate_all_period: calculateAll
          })
          .then((res: any) => {
            return res;
          });
        return res;
      }
    },
    {
      enabled:
        !!selectedCurrencyPid ||
        !!dateFrom ||
        !!adjustedDateTo ||
        !!calculateAll ||
        !!updatePaymenBox
    }
  );

  const totalAmount = data?.total_amount || 0;
  const totalPaidAmount = data?.total_paid_amount || 0;
  const totalWaitingAmount = data?.total_waiting_amount || 0;
  const totalExpiredAmount = data?.total_expired_amount || 0;

  return (
    <div className={styles.container}>
      <div className={theme === 'dark' ? styles.boxDark : styles.box}>
        <h3>{t('total')}</h3>
        <CountUp
          end={totalAmount || 0}
          duration={2.75}
          // suffix={
          //   selectedCurrencyId === 'd69b53bd-da93-4db6-9108-c31210ca5c8f'
          //     ? ` ${t('sum')}`
          //     : ' $'
          // }
          separator=" "
          delay={0}
        >
          {({ countUpRef }) => (
            <div>
              <p ref={countUpRef as LegacyRef<HTMLHeadingElement>}></p>
            </div>
          )}
        </CountUp>
      </div>

      <div className={theme === 'dark' ? styles.boxDark : styles.box}>
        <h3>{t('paid')}</h3>
        <CountUp
          end={totalPaidAmount || 0}
          duration={2.75}
          // suffix={
          //   selectedCurrencyId === 'd69b53bd-da93-4db6-9108-c31210ca5c8f'
          //     ? ` ${t('sum')}`
          //     : ' $'
          // }
          separator=" "
          delay={0}
        >
          {({ countUpRef }) => (
            <div>
              <p ref={countUpRef as LegacyRef<HTMLHeadingElement>}></p>
            </div>
          )}
        </CountUp>
      </div>

      <div className={theme === 'dark' ? styles.boxDark : styles.box}>
        <h3>{t('remaining')}</h3>
        <CountUp
          end={totalWaitingAmount || 0}
          duration={2.75}
          // suffix={
          //   selectedCurrencyId === 'd69b53bd-da93-4db6-9108-c31210ca5c8f'
          //     ? ` ${t('sum')}`
          //     : ' $'
          // }
          separator=" "
          delay={0}
        >
          {({ countUpRef }) => (
            <div>
              <p ref={countUpRef as LegacyRef<HTMLHeadingElement>}></p>
            </div>
          )}
        </CountUp>
      </div>

      <div className={theme === 'dark' ? styles.boxDark : styles.box}>
        <h3>{t('overdue')}</h3>
        <CountUp
          end={totalExpiredAmount || 0}
          duration={2.75}
          // suffix={
          //   selectedCurrencyId === 'd69b53bd-da93-4db6-9108-c31210ca5c8f'
          //     ? ` ${t('sum')}`
          //     : ' $'
          // }
          separator=" "
          delay={0}
        >
          {({ countUpRef }) => (
            <div>
              <p ref={countUpRef as LegacyRef<HTMLHeadingElement>}></p>
            </div>
          )}
        </CountUp>
      </div>
    </div>
  );
};

export default InstallmentReportBoxeses;
